import { render, staticRenderFns } from "./LIST_MATCH.vue?vue&type=template&id=5348cbc4&scoped=true&"
import script from "./LIST_MATCH.vue?vue&type=script&lang=js&"
export * from "./LIST_MATCH.vue?vue&type=script&lang=js&"
import style0 from "./LIST_MATCH.vue?vue&type=style&index=0&id=5348cbc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5348cbc4",
  null
  
)

export default component.exports